import React, { useState } from "react";
import QuantumLab from "./components/Quantum/QuantumLab";
import ShorPlayground from "./components/Shor/ShorPlayground";
import ClassicalLab from "./components/Classical/ClassicalLab";
import "./App.css";
import QuantumEntanglementLab from "./components/Quantum/Entanglement/QuantumEntanglementLab";
import QuantumCircuitSimulator from "./components/Builder/QuantumCircuitSimulator";

import QuantumAlgorithmSandbox from "./components/Sandbox/QuantumAlgorithmSandbox";
import QuantumEntanglementPlayground from "./components/Playground/QuantumEntanglementPlayground";

import QuantumLivePortal from "./components/Training/QuantumLivePortal";
import QuantumResearch from "./components/Research/QuantumResearch";
import QuantumResearchEcho from "./components/Research/QuantumResearchEcho";
import QuantumPhysics from "./components/Physics/QuantumPhysics";

export default function App() {
  const [tab, setTab] = useState("quantum");

  return (
    <div>
      <header>
        <h1>Degen Den Academy – Quantum Lab</h1>
        <p className="subtitle">Learn Quantum Computing with us.</p>
      </header>

      <div className="tabs">
        {/* <button
          className={tab === "training" ? "active" : ""}
          onClick={() => setTab("training")}
        >
          QC Course (LIVE)
        </button> */}
        {/* <button
          className={tab === "classical" ? "active" : ""}
          onClick={() => setTab("classical")}
        >
          Classical Computing
        </button> */}

        <button
          className={tab === "physics" ? "active" : ""}
          onClick={() => setTab("physics")}
        >
          Quantum Physics
        </button>

        <button
          className={tab === "quantum" ? "active" : ""}
          onClick={() => setTab("quantum")}
        >
          Quantum Computing
        </button>

        <button
          className={tab === "research" ? "active" : ""}
          onClick={() => setTab("research")}
        >
          Quantum Research
        </button>

        <button
          className={tab === "circuit" ? "active" : ""}
          onClick={() => setTab("circuit")}
        >
          Quantum Circuit Builder
        </button>

        <button
          className={tab === "algorithms" ? "active" : ""}
          onClick={() => setTab("algorithms")}
        >
          Quantum Algorithms
        </button>

        <button
          className={tab === "entanglement" ? "active" : ""}
          onClick={() => setTab("entanglement")}
        >
          Entanglement Playground
        </button>
      </div>

      {tab === "quantum" ? (
        <QuantumLab />
      ) : tab === "physics" ? (
        <QuantumPhysics />
      ) : tab === "circuit" ? (
        <QuantumCircuitSimulator />
      ) : tab === "algorithms" ? (
        <QuantumAlgorithmSandbox />
      ) : tab === "entanglement" ? (
        <QuantumEntanglementPlayground />
      ) : tab === "research" ? (
        <QuantumResearch />
      ) : (
        <ClassicalLab />
      )}

      {/* {tab === "quantum" ? (
        <QuantumLab />
      ) : tab === "circuit" ? (
        <QuantumCircuitSimulator />
      ) : tab === "algorithms" ? (
        <QuantumAlgorithmSandbox />
      ) : tab === "entanglement" ? (
        <QuantumEntanglementPlayground />
      ) : tab === "training" ? (
        <QuantumLivePortal />
      ) : (
        <ClassicalLab />
      )} */}
    </div>
  );
}
